import { ref } from 'vue'
import axios from 'axios'
import { loading } from '@/utils/loading'
import { tokenInvalid } from '@/utils/nativeAPI'
import CryptoJS from 'crypto-js'
import { useUserStore } from '@/stores/user'
import cn from '../langs/zh'
import lang from '@/langs'
import { showToast } from 'vant'

const instance = axios.create()

instance.defaults.baseURL = import.meta.env.VITE_APP_API_BASE_URL
instance.defaults.withCredentials = false
instance.defaults.timeout = 30000
const key = import.meta.env.VITE_APP_kSignMD5Key
const count = ref(0)
let timmer: number = -1

function hideLoading() {
  timmer = window.setTimeout(() => {
    if (count.value === 0) {
      loading.hide()
    }
  }, 16)
}

function setRequestCount() {
  if (count.value > 0) {
    count.value--
  } else {
    count.value = 0
  }
  hideLoading()
}
type CNKeys = keyof typeof cn
export const errorMessages: Record<number, CNKeys> = {
  15001: 'JMS系统驿站账户未开账，请联系管理员',
  15002: '积分充值财务异常,请联系客服',
  15003: '不存在审核中的积分充值记录',
  15004: '不存在处理中的兑换记录',
  15005: '参数积分总价与实际总价不符',
  15006: '账户中积分余额不足,请充值',
  15007: '物料申请数据未找到',
  15008: '物料兑换申请已被审核,无法取消',
  15009: '物料信息未找到',
  15010: '积分充值失败,请联系客户',
  15011: '积分充值金额必须要在0.01~50000.00范围内',
  15012: '当前物料兑换信息无法取消兑换，请刷新数据',
  15013: '当前物料兑换信息无法取消兑换，请刷新数据'
}
export const handleApiError = (code: number): CNKeys => {
  return errorMessages[code] || '未知错误'
}
instance.interceptors.request.use((config) => {
  const { header } = useUserStore()
  // const header = {
  //   sysCode: 'APP',
  //   appVersion: 'V1.6.1',
  //   systemName: 'IOS',
  //   systemVersion: 'IOS 15.5',
  //   devInfo: 'iPhone13,1',
  //   did: 'BB5A6FE0-6228-4FD8-96AB-8DDDC5C3112F',
  //   ip: '39.108.104.238',
  //   mac: '88:40:3B:41:A3:B5',
  //   lal: 139.12312312,
  //   language: 'cn',
  //   Accept: 'application/json',
  //   authToken:
  //     'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjdXJyZW50VXNlciI6IjJ3VlpBb2tDSmpKYjgzZGdjT2ZvOXMwWGNTSHJ6ZGJsTTVuUk4xYjlIR3BhV0FFcnlabHNSNmVBOFJMR2NvUDluTG5jZGZjV2JYeWxWZU8xRE1aYnlRMk9hUURFNkRxNXZSVW1DN1Fqcmo1ZTRYMFdjcmZYMHViM2ljbVdSZmQyQjdJUlhuSlBNQnFsYXVFaGp6dytyR1Q2NkRFcXhMbUJnVFRQWXErYnhTVVorbGUrRDNxS2ZTcklVTFdHVWpVNGE1alA1MXI0dFNmMyt6WElxQ1kvOWF2VHoxQk90RXM2L3ozZDAwbjlwaU1XVi81ZkRZbzg5R3Z2ZkpJenZOc2liUTU5b2dCVkVKMGVWOXY3QThkOFRCTkNKN2w2bS9rRS9VVnNYTHZMUUkxWUZFbUpYWHZHN1VUcWdnTUloWFFiN2JhQ2RvUE8xTVpLMEdMSCtIeUJoWkF2OEx2aGt2Y2FkS3NNQU16K0tCQlUyU1BvWWhGMTlDaFU3YXExQkh3aUQrNnBuRHE3MU4rZGRPMzNYNzVYTDFDOWRuT2ZtOTRWRWVVVDNENHdySHdUVDNKOXJLaitXVldjblpyOFp2ZnhTSWNPU0Z5My9qUHo3WUxKUDZmalNyMmxudlZUSDdjVDViMUJiK3Q1YVU3d3hrRVpXM3MxTG0yZkVPNnZ4UjZ0IiwiZXhwIjoxNzQ0MDc2NjkzLCJpYXQiOjE3NDM5OTAyOTN9.V4EZa6n4Qk-xx6m-Xx4GZ9swjdu878Xuz4087IOCkuM',
  //   // 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjdXJyZW50VXNlciI6IjJ3VlpBb2tDSmpKYjgzZGdjT2ZvOXMwWGNTSHJ6ZGJsTTVuUk4xYjlIR3BhV0FFcnlabHNSNmVBOFJMR2NvUDluTG5jZGZjV2JYeWxWZU8xRE1aYnlRMk9hUURFNkRxNXZSVW1DN1Fqcmo1ZTRYMFdjcmZYMHViM2ljbVdSZmQyQjdJUlhuSlBNQnFsYXVFaGp6dytyR1Q2NkRFcXhMbUJnVFRQWXErYnhTVVorbGUrRDNxS2ZTcklVTFdHVWpVNGE1alA1MXI0dFNmMyt6WElxQ1kvOWF2VHoxQk90RXM2L3ozZDAwbjlwaU1XVi81ZkRZbzg5R3Z2ZkpJenZOc2liUTU5b2dCVkVKMGVWOXY3QThkOFRCTkNKN2w2bS9rRS9VVnNYTHZMUUkxWUZFbUpYWHZHN1VUcWdnTUloWFFiN2JhQ2RvUE8xTVpLMEdMSCtIeUJoWkF2OEx2aGt2Y2FkS3NNQU16K0tCQlUyU1BvWWhGMTlDaFU3YXExQkh3aUQrNnBuRHE3MU4rZGRPMzNYNzVYTDFDOWRuT2ZtOTRWRWVVVDNENHdySHdUVDNKOXJLaitXVldjblpyOFp2ZnhTSWNPU0Z5My9qUHo3WUxKUDZmalNyMmxudlZUSDdjVDViMUJiK3Q1YVU3d3hrRVpXM3MxTG0yZkVPNnZ4UjZ0IiwiZXhwIjoxNzQyMzcwMTgyLCJpYXQiOjE3NDIyODM3ODJ9.p7AlXZoseS3F-FwJwpaEEHbdqmdngMCJAD5g4YTjc4Y',
  //   ts: 1734083844000,
  //   timezone: 'Asia/Bangkok',
  //   tmpsign: 'F9EC3C2372CB3A262A16EED102BAF0C8'
  // }
  if (config.loadingShow === '1') {
    clearTimeout(timmer)
    loading.show()
    count.value++
  }
  config.headers.Accept = 'application/json'
  // config.headers['Content-Type'] = 'application/json'
  config.headers = { ...config.headers, ...header }
  config.headers.ts = Date.now()
  const tempData = config?.data || {}
  const sortedData = Object.keys(tempData)
    .sort() // 默认按字母升序排序
    .reduce((acc, key) => {
      acc[key] = tempData[key]
      return acc
    }, {})
  const data = JSON.stringify(sortedData)
  let temp = `${data}&ts=${config.headers.ts}&signKey=${key}`
  temp = temp.replace(/"/g, '')
  config.headers.tmpsign = CryptoJS.MD5(temp).toString()
  config.headers.tmpsign = config.headers.tmpsign.toUpperCase()
  return config
})

instance.interceptors.response.use(
  async (res) => {
    if (res.config?.loadingShow === '1') {
      setRequestCount()
    }
    const { code, msg } = res.data
    // if (res.config.toastShow === '1') {
    if (
      code == 40001 ||
      code == 40002 ||
      code == 40011 ||
      code == 40021 ||
      code == 40003 ||
      code == 40010
    ) {
      showToast(msg)
      setTimeout(() => {
        tokenInvalid(code)
      }, 500)
    }
    // }

    return Promise.resolve(res.data || {})
  },
  (error) => {
    // if (error.config?.loadingShow !== '0') {
    count.value = 0
    hideLoading()
    // }

    return Promise.resolve(error || {})
  }
)

export default instance
